/**
 *
 * @Copyright 2024 UNLOCK DECENTRALIZATION, LDA
 * Development by VOID Software, SA
 *
 */

export const PlaceholderWidth = 105;
export const PlaceholderHeight = 55;
